import {
  BarChart as RechartsBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell,
} from 'recharts'

const COLORS = [
  'hsl(217, 91%, 30%)',
  'hsl(142, 76%, 36%)',
  'hsl(0, 84%, 60%)',
  'hsl(38, 92%, 50%)',
  'hsl(262, 83%, 58%)',
  'hsl(199, 89%, 48%)',
]

interface BarChartProps {
  data: Record<string, any>[]
  xKey: string
  bars: { key: string; name?: string; color?: string }[]
  height?: number
  xTickFormatter?: (value: any) => string
  yTickFormatter?: (value: any) => string
  tooltipFormatter?: (value: any) => string
  showGrid?: boolean
  showLegend?: boolean
  layout?: 'horizontal' | 'vertical'
  colorByValue?: boolean // positive=green, negative=red
}

export default function BarChart({
  data,
  xKey,
  bars,
  height = 300,
  xTickFormatter,
  yTickFormatter,
  tooltipFormatter,
  showGrid = true,
  showLegend = true,
  layout = 'horizontal',
  colorByValue = false,
}: BarChartProps) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <RechartsBarChart
        data={data}
        layout={layout === 'vertical' ? 'vertical' : 'horizontal'}
        margin={{ top: 5, right: 20, left: 10, bottom: 5 }}
      >
        {showGrid && <CartesianGrid strokeDasharray="3 3" stroke="hsl(214, 32%, 91%)" />}
        {layout === 'vertical' ? (
          <>
            <XAxis type="number" tick={{ fontSize: 12, fill: 'hsl(215, 16%, 47%)' }} tickFormatter={yTickFormatter} />
            <YAxis type="category" dataKey={xKey} tick={{ fontSize: 12, fill: 'hsl(215, 16%, 47%)' }} width={120} tickFormatter={xTickFormatter} />
          </>
        ) : (
          <>
            <XAxis dataKey={xKey} tick={{ fontSize: 12, fill: 'hsl(215, 16%, 47%)' }} tickFormatter={xTickFormatter} />
            <YAxis tick={{ fontSize: 12, fill: 'hsl(215, 16%, 47%)' }} tickFormatter={yTickFormatter} />
          </>
        )}
        <Tooltip
          contentStyle={{
            backgroundColor: 'hsl(0, 0%, 100%)',
            border: '1px solid hsl(214, 32%, 91%)',
            borderRadius: '0.5rem',
            fontSize: 12,
          }}
          formatter={tooltipFormatter ? (value: any) => tooltipFormatter(value) : undefined}
        />
        {showLegend && bars.length > 1 && <Legend wrapperStyle={{ fontSize: 12 }} />}
        {bars.map((bar, i) => (
          <Bar key={bar.key} dataKey={bar.key} name={bar.name || bar.key} fill={bar.color || COLORS[i % COLORS.length]} radius={[2, 2, 0, 0]}>
            {colorByValue &&
              data.map((entry, idx) => (
                <Cell key={idx} fill={entry[bar.key] >= 0 ? 'hsl(142, 76%, 36%)' : 'hsl(0, 84%, 60%)'} />
              ))}
          </Bar>
        ))}
      </RechartsBarChart>
    </ResponsiveContainer>
  )
}
